import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import {
  Box,
  Card,
  CardContent,
  Button,
  CircularProgress,
  Alert,
} from '@mui/material';
import { useSettingsStore } from '../../stores/root_store';
import { ProfileForm } from '../../components/settings/ProfileForm';
import { EmailAddresses } from '../../components/settings/EmailAddresses';
import type { UserProfile } from '../../types';

export const SettingsEdit = observer(() => {
  const settingsStore = useSettingsStore();
  const [profile, setProfile] = useState<UserProfile | null>(null);
  const [hasChanges, setHasChanges] = useState(false);

  useEffect(() => {
    if (settingsStore.settings) {
      setProfile(settingsStore.settings.profile);
      setHasChanges(false);
    }
  }, [settingsStore.settings]);

  const handleSave = async () => {
    if (!profile || !settingsStore.settings) return;
    const success = await settingsStore.updateSettings({
      ...profile,
      ...settingsStore.settings.email_preferences,
    });
    if (success) {
      setHasChanges(false);
    }
  };

  if (!profile) {
    return null;
  }

  return (
    <>
      <Card>
        <CardContent>
          {settingsStore.error && (
            <Alert
              severity="error"
              sx={{ mb: 2 }}
              onClose={() => settingsStore.clearError()}
            >
              {settingsStore.error}
            </Alert>
          )}

          <ProfileForm
            profile={profile}
            onChange={(p) => {
              setProfile(p);
              setHasChanges(true);
            }}
            disabled={settingsStore.saving}
          />

          <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              variant="contained"
              onClick={handleSave}
              disabled={!hasChanges || settingsStore.saving}
            >
              {settingsStore.saving ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                'Save Changes'
              )}
            </Button>
          </Box>
        </CardContent>
      </Card>
      <Card sx={{ mt: 3 }}>
        <CardContent>
          <EmailAddresses />
        </CardContent>
      </Card>
    </>
  );
});
